import { Companion_getInstance3d08n7snrwep7 as Companion_getInstance } from './ExecutionContext.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { HttpHeader1d7ldebjomr00 as HttpHeader } from './http/Http.mjs';
import { plus20p0vtfmu0596 as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { uuid4al7pp0fcb8o5 as uuid4 } from '../../../../../uuid/com/benasher44/uuid/uuid.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(operation) {
        this.v41_1 = operation;
        this.w41_1 = null;
        this.x41_1 = Companion_getInstance().i42_1;
        this.y41_1 = null;
        this.z41_1 = null;
        this.a42_1 = null;
        this.b42_1 = null;
        this.c42_1 = null;
        this.d42_1 = null;
        this.e42_1 = null;
        this.f42_1 = null;
        this.g42_1 = null;
        this.h42_1 = true;
      }
      j42(requestUuid) {
        // Inline function 'kotlin.apply' call
        this.w41_1 = requestUuid;
        return this;
      }
      k42(executionContext) {
        // Inline function 'kotlin.apply' call
        this.x41_1 = executionContext;
        return this;
      }
      l42(ignoreApolloClientHttpHeaders) {
        // Inline function 'kotlin.apply' call
        this.e42_1 = ignoreApolloClientHttpHeaders;
        return this;
      }
      m42(httpMethod) {
        // Inline function 'kotlin.apply' call
        this.y41_1 = httpMethod;
        return this;
      }
      n42(httpHeaders) {
        // Inline function 'kotlin.apply' call
        this.z41_1 = httpHeaders;
        return this;
      }
      o42(name, value) {
        // Inline function 'kotlin.apply' call
        var tmp = this;
        var tmp0_elvis_lhs = this.z41_1;
        tmp.z41_1 = plus(tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs, new (HttpHeader())(name, value));
        return this;
      }
      p42(sendApqExtensions) {
        // Inline function 'kotlin.apply' call
        this.b42_1 = sendApqExtensions;
        return this;
      }
      q42(sendDocument) {
        // Inline function 'kotlin.apply' call
        this.c42_1 = sendDocument;
        return this;
      }
      r42(enableAutoPersistedQueries) {
        // Inline function 'kotlin.apply' call
        this.a42_1 = enableAutoPersistedQueries;
        return this;
      }
      s42(canBeBatched) {
        // Inline function 'kotlin.apply' call
        this.d42_1 = canBeBatched;
        return this;
      }
      t42(retryOnError) {
        // Inline function 'kotlin.apply' call
        this.f42_1 = retryOnError;
        return this;
      }
      u42(failFastIfOffline) {
        // Inline function 'kotlin.apply' call
        this.g42_1 = failFastIfOffline;
        return this;
      }
      v42(sendEnhancedClientAwareness) {
        // Inline function 'kotlin.apply' call
        this.h42_1 = sendEnhancedClientAwareness;
        return this;
      }
      d37() {
        var tmp0_elvis_lhs = this.w41_1;
        return new (ApolloRequest())(this.v41_1, tmp0_elvis_lhs == null ? uuid4() : tmp0_elvis_lhs, this.x41_1, this.y41_1, this.z41_1, this.b42_1, this.c42_1, this.a42_1, this.d42_1, this.e42_1, this.f42_1, this.g42_1, this.h42_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var ApolloRequestClass;
function ApolloRequest() {
  if (ApolloRequestClass === VOID) {
    class $ {
      constructor(operation, requestUuid, executionContext, httpMethod, httpHeaders, sendApqExtensions, sendDocument, enableAutoPersistedQueries, canBeBatched, ignoreApolloClientHttpHeaders, retryOnError, failFastIfOffline, sendEnhancedClientAwareness) {
        this.w42_1 = operation;
        this.x42_1 = requestUuid;
        this.y42_1 = executionContext;
        this.z42_1 = httpMethod;
        this.a43_1 = httpHeaders;
        this.b43_1 = sendApqExtensions;
        this.c43_1 = sendDocument;
        this.d43_1 = enableAutoPersistedQueries;
        this.e43_1 = canBeBatched;
        this.f43_1 = ignoreApolloClientHttpHeaders;
        this.g43_1 = retryOnError;
        this.h43_1 = failFastIfOffline;
        this.i43_1 = sendEnhancedClientAwareness;
      }
      j43() {
        return this.k43(this.w42_1);
      }
      k43(operation) {
        return (new (Builder())(operation)).j42(this.x42_1).k42(this.y42_1).m42(this.z42_1).n42(this.a43_1).p42(this.b43_1).q42(this.c43_1).r42(this.d43_1).s42(this.e43_1).t42(this.g43_1).u42(this.h43_1).l42(this.f43_1).v42(this.i43_1);
      }
    }
    initMetadataForClass($, 'ApolloRequest');
    ApolloRequestClass = $;
  }
  return ApolloRequestClass;
}
//region block: exports
export {
  Builder as Builder32honxq3tatym,
};
//endregion

//# sourceMappingURL=ApolloRequest.mjs.map
